/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Field_Email_PlaceholderInputs */

const en_auth_field_email_placeholder = /** @type {(inputs: Auth_Field_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m@example.com`)
};

/**
* | output |
* | --- |
* | "m@example.com" |
*
* @param {Auth_Field_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_field_email_placeholder = /** @type {((inputs?: Auth_Field_Email_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Field_Email_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_field_email_placeholder(inputs)
});